// return prod, staging, dev based on current environment
export const currentEnvironment = () => {
  if (typeof window !== "undefined") {
    if (window.location.hostname === "localhost") {
      return "dev";
    } else if (
      window.location.hostname.includes("staging") ||
      window.location.hostname.includes("vercel")
    ) {
      return "staging";
    } else {
      return "prod";
    }
  }
};
